/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  PostMatchesMatchidChampionPoolsMutationResponse,
  PostMatchesMatchidChampionPoolsPathParams,
  PostMatchesMatchidChampionPoolsQueryParams,
  PostMatchesMatchidChampionPools403,
} from "../types/PostMatchesMatchidChampionPools.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postMatchesMatchidChampionPoolsMutationKey = () =>
  [{ url: "/matches/:matchId/champion-pools" }] as const;

export type PostMatchesMatchidChampionPoolsMutationKey = ReturnType<
  typeof postMatchesMatchidChampionPoolsMutationKey
>;

/**
 * @summary KAN-1676: выдать пулы на игру серии. Право — организатор/tournament staff
 * (та же проверка, что у управления пре-драфтом). Идемпотентно: повторный вызов
 * на уже выданную игру возвращает сохранённый пул и не перегенерирует его.
 * {@link /matches/:matchId/champion-pools}
 */
export async function postMatchesMatchidChampionPools(
  matchId: PostMatchesMatchidChampionPoolsPathParams["matchId"],
  params?: PostMatchesMatchidChampionPoolsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostMatchesMatchidChampionPoolsMutationResponse,
    ResponseErrorConfig<PostMatchesMatchidChampionPools403>,
    unknown
  >({
    method: "POST",
    url: `/matches/${matchId}/champion-pools`,
    params,
    ...requestConfig,
  });
  return res;
}

export function postMatchesMatchidChampionPoolsMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = postMatchesMatchidChampionPoolsMutationKey();
  return mutationOptions<
    ResponseConfig<PostMatchesMatchidChampionPoolsMutationResponse>,
    ResponseErrorConfig<PostMatchesMatchidChampionPools403>,
    {
      matchId: PostMatchesMatchidChampionPoolsPathParams["matchId"];
      params?: PostMatchesMatchidChampionPoolsQueryParams;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ matchId, params }) => {
      return postMatchesMatchidChampionPools(matchId, params, config);
    },
  });
}

/**
 * @summary KAN-1676: выдать пулы на игру серии. Право — организатор/tournament staff
 * (та же проверка, что у управления пре-драфтом). Идемпотентно: повторный вызов
 * на уже выданную игру возвращает сохранённый пул и не перегенерирует его.
 * {@link /matches/:matchId/champion-pools}
 */
export function usePostMatchesMatchidChampionPools<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<PostMatchesMatchidChampionPoolsMutationResponse>,
      ResponseErrorConfig<PostMatchesMatchidChampionPools403>,
      {
        matchId: PostMatchesMatchidChampionPoolsPathParams["matchId"];
        params?: PostMatchesMatchidChampionPoolsQueryParams;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postMatchesMatchidChampionPoolsMutationKey();

  const baseOptions = postMatchesMatchidChampionPoolsMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<PostMatchesMatchidChampionPoolsMutationResponse>,
    ResponseErrorConfig<PostMatchesMatchidChampionPools403>,
    {
      matchId: PostMatchesMatchidChampionPoolsPathParams["matchId"];
      params?: PostMatchesMatchidChampionPoolsQueryParams;
    },
    TContext
  >;

  return useMutation<
    ResponseConfig<PostMatchesMatchidChampionPoolsMutationResponse>,
    ResponseErrorConfig<PostMatchesMatchidChampionPools403>,
    {
      matchId: PostMatchesMatchidChampionPoolsPathParams["matchId"];
      params?: PostMatchesMatchidChampionPoolsQueryParams;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<PostMatchesMatchidChampionPoolsMutationResponse>,
    ResponseErrorConfig<PostMatchesMatchidChampionPools403>,
    {
      matchId: PostMatchesMatchidChampionPoolsPathParams["matchId"];
      params?: PostMatchesMatchidChampionPoolsQueryParams;
    },
    TContext
  >;
}
